import React from 'react';
import { stats } from '../data/content';
export function StatsBar() {
  return <section className="w-full border-y border-plum-100 bg-white py-10 md:py-12" data-id="element-213" data-mp="1tarjq9bipqkw">
      <div className="mx-auto w-full max-w-content px-5 md:px-8" data-id="element-214" data-mp="1t8njq2gqpbpw">
        <dl className="grid grid-cols-2 gap-y-8 divide-plum-100 text-center md:grid-cols-4 md:divide-x" data-id="element-215" data-mp="1o9u2byyc10kg">
          {stats.map(stat => <div key={stat.label} className="px-4" data-id="element-216" data-mp="1ed7kzk57srn6">
              <dd className="font-display text-[2.4rem] font-extrabold leading-none tracking-tight text-plum-700" data-id="element-217" data-mp="1ee0rql46bh5b">
                {stat.value}
              </dd>
              <dt className="mt-3 text-[0.7rem] font-bold uppercase tracking-[0.16em] text-muted" data-id="element-218" data-mp="15ke0n8awv22g">
                {stat.label}
              </dt>
            </div>)}
        </dl>
      </div>
    </section>;
}